import {Inject, Injectable} from '@angular/core';
import {Observable, ReplaySubject, Subject} from "rxjs";
import {CountedAndPaginated} from "../interface/response/counted-and-paginated";
import {AddressImportRow} from "../interface/address-import-row";
import {first, take} from "rxjs/operators";
import {HttpClient} from "@angular/common/http";
import {FilterService} from "./filter.service";
import {DOCUMENT} from "@angular/common";
import {ListResponse} from "../interface/response/list-response";
import {Partner} from "../interface/partner";

@Injectable({
  providedIn: 'root'
})
export class AddressImportRowService {

  private readonly addressImportRowListSubject: ReplaySubject<CountedAndPaginated<AddressImportRow>>
    = new ReplaySubject<CountedAndPaginated<AddressImportRow>>(1);
  private readonly  addressImportRowNotCountedListSubject: ReplaySubject<ListResponse<AddressImportRow>> = new ReplaySubject<ListResponse<AddressImportRow>>(1);


  constructor(
    private httpClient: HttpClient,
    private filterService: FilterService,
    @Inject(DOCUMENT) private document: Document,
  ) { }

  public loadList(page: number, pageSize: number, filters: object): void {
    this.httpClient.get(`/rest/crm/address-import-row?page=${page + 1}&pageSize=${pageSize}&` + this.filterService.parseFilters(filters))
      .pipe(
        first()
      )
      .subscribe((result: CountedAndPaginated<AddressImportRow>) => {
        this.addressImportRowListSubject.next(result);
      });
  }

  public loadNotCountedList(page: number, pageSize: number, filters: object, observable?: Subject<ListResponse<AddressImportRow>>): void {
    this.httpClient
      .get(`/rest/crm/address-import-row?disableCount=1&page=${page + 1}&pageSize=${pageSize}&` + this.filterService.parseFilters(filters))
      .pipe(take(1))
      .subscribe((result: ListResponse<AddressImportRow>) => {
        if (observable) {
          observable.next(result);
        } else {
          this.addressImportRowNotCountedListSubject.next(result);
        }
      });
  }

  public getAddressImportRowListSubject(): ReplaySubject<CountedAndPaginated<AddressImportRow>> {
    return this.addressImportRowListSubject;
  }

  public send(formData: object): Observable<any> {
    return this.httpClient.post(`/rest/crm/address-import-row`, formData)
      .pipe(
        take(1)
      );
  }
}
